'use client'

import { getInsightsHref } from '@/components/links/insights'
import InsightsRoute from '@/lib/routes/insights'
import IconSearch from '@icon/variable/search.svg'
import { useRouter } from 'next/navigation'
import { useMemo } from 'react'
import { useInsightsContext } from '../../context'

export default function InsightsSearch() {
  const router = useRouter()
  const { query } = useInsightsContext()
  const defaultText = useMemo(() => {
    if (!query) {
      return ''
    }
    const route = new InsightsRoute()
    route.fromSlug(query)
    return route.getVal('search') || ''
  }, [query])

  function handleSearch(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault()
    const formData = new FormData(event.currentTarget)
    const searchQuery = (formData.get('search') as string).trim()

    if (!searchQuery) {
      return router.push(getInsightsHref())
    }

    const route = new InsightsRoute()
    route.setVal('search', searchQuery)
    router.push(getInsightsHref(route.getSlug()), { scroll: false })
  }

  return (
    <form
      onSubmit={handleSearch}
      className='flex items-center border border-secondary/20 rounded-sm px-1 gap-x-2'
    >
      <IconSearch className='fill-secondary/20 w-4 h-4' />
      <input
        type='text'
        placeholder='Search insights...'
        name='search'
        className='h-9.5'
        defaultValue={defaultText}
      />
    </form>
  )
}
